import { render, staticRenderFns } from "./co-create-with-pubgm-pdp.vue?vue&type=template&id=689d73c6&scoped=true&"
import script from "./co-create-with-pubgm-pdp.vue?vue&type=script&lang=js&"
export * from "./co-create-with-pubgm-pdp.vue?vue&type=script&lang=js&"
import style0 from "./co-create-with-pubgm-pdp.vue?vue&type=style&index=0&id=689d73c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689d73c6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Atlas: require('/var/jenkins_home/workspace/prod-web-xfans/components/atlas.vue').default})
